import React, {useRef, useContext} from 'react';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {useNavigate} from 'react-router';
import {Card, ListGroup} from 'react-bootstrap';
import { MadricContext } from '../../../Context/MadricContext';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash, faPencilAlt, faArrowRight} from '@fortawesome/free-solid-svg-icons';


/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function PDF(props) {

    const {setWhatToShow, setActiveLink} = useContext(MadricContext);
    const returnTo = 'global';
    const file = props.file;
    const id = props.file.place_id;
    const navigate = useNavigate();


  return (
    <div className="checkin-container" style={{minWidth: '90%'}}>
      <Card className="checkin-card" style={{minWidth: '90%'}}>
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>PDF</span> {props.formatDate(props.file.date)}
          <button style={{marginLeft:"5px"}} className="checkin-pagination-button float-end" onClick={() => {setWhatToShow('5'); navigate('/chantier/' + props.file.place_id); setActiveLink('chantiers')}}><FontAwesomeIcon icon={faArrowRight} /></button>
          <button className="checkin-pagination-button float-end" onClick={() => {navigate('/UpdateFile', {state: {file,id, returnTo}}); setActiveLink('chantiers')}}><FontAwesomeIcon icon={faPencilAlt} /></button>
        </Card.Header>

        <ListGroup variant="flush">
        

          <ListGroup.Item className="checkin-list-item" style={{fontWeight:"bold", fontSize:"18px"}}>
          {props.file.user_name}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">
          Projet: {props.file.chantier}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">
          Permission: {props.file.permission ? 'OUI' : 'NON'}
          </ListGroup.Item>

          <ListGroup.Item>
            <MDBCheckbox
              name="extra1"
              id="inlineCheckbox111"
              defaultChecked={props.file.extra1}
              label="Extra possible"
              inline
            />
            {localStorage.getItem('admin') === '1' ? (
            <React.Fragment>
              <MDBCheckbox
                name="extra2"
                id="inlineCheckbox222"
                defaultChecked={props.file.extra2}
                label="Extra valider"
                inline
              />
              <MDBCheckbox
                name="extra3"
                id="inlineCheckbox333"
                defaultChecked={props.file.extra3}
                label="Extra confirmer"
                inline
              />
            </React.Fragment>
          ) : (
            ' '
          )}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item ">
          Note: {props.file.note}
          </ListGroup.Item>

        </ListGroup>
      </Card>

    </div>
  );
}

export default PDF;
